import { FC } from 'react';
import { IHouseSubscriptionBannerProps } from '../../types';
import styles from './HouseSubscriptionBannerMobile.css';
import { Button, UIHeading4, UIText2 } from '@cian/ui-kit';

export const HouseSubscriptionBannerMobile: FC<IHouseSubscriptionBannerProps> = ({
  title,
  subtitle,
  buttonText,
  onClick,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <div className={styles['title']}>
          <UIHeading4>{title}</UIHeading4>
        </div>
        <div className={styles['subtitle']}>
          <UIText2>{subtitle}</UIText2>
        </div>
        <Button onClick={onClick} size="M" theme="fill_primary">
          {buttonText}
        </Button>
      </div>
      <div className={styles['image']} />
    </div>
  );
};
